import React, { lazy, Suspense } from 'react';
import { ThemeProvider } from 'styled-components';
import { Route, Routes } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import Admin from './routes/admin';
import Auth from './routes/auth';
import './static/css/style.css';
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';
import 'antd/dist/antd.less';
import { useChangeLayoutModeStore } from './store/themeLayout/themeLayoutStore';
import { useAuthenticationStore } from './store/authentication/authenticationStore';

const NotFound = lazy(() => import('./pages/NotFound'));
const RedirectDashboard = lazy(() => import('./pages/RedirectDashboard'));

const { themeColor } = config;

function ProviderConfig() {
  const rtl = useChangeLayoutModeStore((state) => state.rtlData);
  const topMenu = useChangeLayoutModeStore((state) => state.topMenu);
  const mainContent = useChangeLayoutModeStore((state) => state.mode);
  const isLoggedIn = useAuthenticationStore((state) => state.login);

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...themeColor, rtl, topMenu, mainContent }}>
        <>
          {/* <Router basename="/"> */}
          <Suspense
            fallback={
              <div className="spin">
                <Spin />
              </div>
            }
          >
            {!isLoggedIn ? (
              <Routes>
                <Route path="/*" element={<Auth />} />{' '}
              </Routes>
            ) : (
              <Routes>
                <Route path="/admin/*" element={<ProtectedRoute path="/*" Component={Admin} />} />
                <Route path="/" element={<RedirectDashboard />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            )}
            {/* {isLoggedIn && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
              <Routes>
                <Route path="/" element={<Navigate to="/admin" />} />
              </Routes>
            )} */}
          </Suspense>
          {/* </Router> */}
        </>
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  return <ProviderConfig />;
}

export default App;
